import { theme } from "@huub-web/ui/theme/css/theme.css";
import { globalStyle, style } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";
import { recipe } from "@vanilla-extract/recipes";
import { transition } from "@huub-web/ui/utils/transition";

export const cardStyle = recipe({
  base: {
    pointerEvents: "auto",
    minHeight: rem(300),
    selectors: {
      "&:before": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        border: "1px solid transparent",
        transition: transition("border-color"),
        borderRadius: theme.borderRadiuses.s,
        zIndex: 3,
        pointerEvents: "none",
      },
    },
  },
  variants: {
    canHover: {
      true: {
        selectors: {
          "&:hover:before": {
            borderColor: theme.colors.primary,
          },
        },
      },
      false: {
        selectors: {
          "&:before": {
            display: "none",
          },
        },
      },
    },
  },
});

export const cardContentStyle = style({
  display: "grid",
  minHeight: "0",
  height: "100%",
  gridTemplateRows: "1fr",
});

globalStyle(".mapbox-map-card .mapboxgl-ctrl-bottom-right", {
  display: "none",
});
globalStyle(".mapbox-map-card *", {
  pointerEvents: "none",
});

export const buttonStyle = style({
  position: "absolute",
  bottom: theme.spacings.s,
  left: theme.spacings.s,
  pointerEvents: "none",
});
